import { prelineCarousel, handleCarouselButtonClicks } from "../components/preline-carousel.js"

export const otCarouselCallouts = {
    init() {
        prelineCarousel();
        handleCarouselButtonClicks();
    }
}